import React, { useState, useEffect, useRef } from 'react';
import { Drawer, IconButton, Link, Box } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import DrawerHeader from './DrawerHeader';
import MenuList from './MenuList';
import DrawerUserInfoContainer from '../../../containers/common/header/DrawerUserInfoContainer';
import { fetchLogoImageBlobUrl } from '../../../lib/api/companyInfo';

import { Link as RouterLink } from 'react-router-dom';

const LeftDrawer = ({
  drawerWidth,
  open,
  handleDrawerClose,
  variant = 'persistent',
  onMenuSelect,
  focusSearchToken,
}) => {
  const [logoBlobUrl, setLogoBlobUrl] = useState(null);
  const logoBlobUrlRef = useRef(null);

  const handleLogoClick = () => {
    if (onMenuSelect) {
      window.setTimeout(onMenuSelect, 0);
    }
  };

  const updateLogo = (url) => {
    if (logoBlobUrlRef.current) URL.revokeObjectURL(logoBlobUrlRef.current);
    logoBlobUrlRef.current = url;
    setLogoBlobUrl(url);
  };

  useEffect(() => {
    fetchLogoImageBlobUrl().then(updateLogo);
    const handler = (e) => {
      const newBlobUrl = e.detail?.blobUrl;
      if (newBlobUrl) updateLogo(newBlobUrl);
      else fetchLogoImageBlobUrl().then(updateLogo);
    };
    window.addEventListener('company-logo-updated', handler);
    return () => window.removeEventListener('company-logo-updated', handler);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Drawer
      sx={{
        width: variant === 'persistent' ? drawerWidth : 'auto',
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          maxWidth: '86vw',
          boxSizing: 'border-box',
        },

      }}
      variant={variant}
      anchor="left"
      open={open}
      onClose={handleDrawerClose}
    // PaperProps={{
    //   sx: {
    //     backgroundColor: "#37474f",
    //     color: "#eceff1",
    //   }
    // }}
    >
      <DrawerHeader sx={{ backgroundColor: '#fafafa' }}>
        <Box sx={{ px: 1 }}>
          <Link component={RouterLink} to="/" onClick={handleLogoClick}>
            <img src={logoBlobUrl || '/static/images/logo/logo.png'} alt="companyLogo" style={{ width: 100, objectFit: 'contain' }} />
              </Link>
        </Box>
        <IconButton onClick={handleDrawerClose} sx={{ color: '#37474f' }}>
          <MenuOpenIcon />
        </IconButton>
      </DrawerHeader>

      <DrawerUserInfoContainer />

      <MenuList onMenuSelect={onMenuSelect} focusSearchToken={focusSearchToken} />
    </Drawer>
  )
}

export default LeftDrawer
